function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var WalletHistoryTemplate = require('./wallet-history.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var WalletHistory = /*#__PURE__*/function () {
  function WalletHistory(app, mod) {
    var _this = this;
    _classCallCheck(this, WalletHistory);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    app.connection.on('saito-crypto-wallet-history-render-request', function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        ticker = _ref.ticker;
      _this.ticker = ticker || _this.app.wallet.returnPreferredCryptoTicker();
      _this.mod = _this.app.wallet.returnCryptoModuleByTicker(_this.ticker);
      void _this.render();
    });
    for (var _i = 0, _arr = ['on-transaction-pending', 'wallet-updated', 'on-payment-sent', 'on-payment-received']; _i < _arr.length; _i++) {
      var event = _arr[_i];
      app.connection.on(event, function () {
        if (_this.overlay.visible) {
          _this.formatHistory();
        }
      });
    }
  }
  return _createClass(WalletHistory, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$mod$history;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(this.mod.ticker === 'SAITO' && !((_this$mod$history = this.mod.history) !== null && _this$mod$history !== void 0 && _this$mod$history.length))) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return this.mod.loadHistory();
            case 1:
              this.overlay.show(WalletHistoryTemplate(this.mod));
              this.formatHistory();
              this.attachEvents();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "formatHistory",
    value: function formatHistory() {
      var _this2 = this,
        _this$mod$history2;
      var balanceHeader = this.mod.ticker === 'SAITO' ? '' : '<div class="saitox-header-item">Balance</div>';
      var formatBalance = function formatBalance(balance) {
        return _this2.mod.ticker === 'SAITO' ? '' : "<div class=\"crypto-amount\">".concat(_this2.app.browser.formatDecimals(balance), "</div>");
      };
      var historyHtml = "\n      <div class=\"transaction-history-table saitox-table\" data-crypto=\"".concat(this.mod.ticker, "\">\n        <div class=\"saitox-header-item\">Time</div>\n        <div class=\"saitox-header-item\">Type</div>\n        <div class=\"saitox-header-item crypto-amount\">Amount</div>\n        ").concat(balanceHeader, "\n        <div class=\"saitox-header-item\">To/From</div>\n        <div class=\"saitox-header-item saito-only\">Memo</div>\n        <div class=\"saitox-header-item saito-only\"></div>\n    ");
      var runningBalance = Number(this.mod.returnDisplayBalance());
      var day = new Date().toDateString();
      var lastTimestamp = 0;
      if (((_this$mod$history2 = this.mod.history) === null || _this$mod$history2 === void 0 ? void 0 : _this$mod$history2.length) > 0) {
        if (this.mod.last_balance) {
          var difference = runningBalance - Number(this.mod.last_balance);
          historyHtml += "<div class=\"crypto-timestamp\"></div>\n          <div class=\"crypto-type-italic\">pending</div>\n          <div class=\"crypto-amount\">".concat(this.app.browser.formatDecimals(difference), "</div>\n          ").concat(formatBalance(runningBalance), "\n          <div></div>\n          <div class=\"saito-only\"></div>\n          <div class=\"saito-only\"></div>");
          runningBalance -= difference;
          runningBalance = Number(runningBalance.toFixed(8));
        }
        for (var i = this.mod.history.length - 1; i >= 0; i--) {
          var _entry$counter_party, _entry$counter_party2;
          var entry = this.mod.history[i];
          if (entry.lc === 0) {
            continue;
          }
          if (entry.timestamp === lastTimestamp) {
            continue;
          }
          lastTimestamp = entry.timestamp;
          var timestamp = new Date(entry.timestamp);
          if (timestamp.toDateString() !== day) {
            day = timestamp.toDateString();
            historyHtml += "<div class=\"saitox-table-break\">".concat(day, "</div>");
          }
          historyHtml += "<div class=\"crypto-timestamp\">".concat(timestamp.toLocaleTimeString().replace(/\s*AM/i, 'am').replace(/\s*PM/i, 'pm'), "</div>\n          <div class=\"crypto-type\">").concat(entry.type, "</div>\n          <div class=\"crypto-amount\">").concat(this.app.browser.formatDecimals(entry.amount), "</div>\n          ").concat(formatBalance(runningBalance));
          if ((_entry$counter_party = entry.counter_party) !== null && _entry$counter_party !== void 0 && _entry$counter_party.publicKey) {
            historyHtml += this.app.browser.returnAddressHTML(entry.counter_party.publicKey);
          } else if ((_entry$counter_party2 = entry.counter_party) !== null && _entry$counter_party2 !== void 0 && _entry$counter_party2.address) {
            if (entry.counter_party.address.indexOf('-') > 0) {
              var addressParts = entry.counter_party.address.split('-');
              historyHtml += "<div class=\"crypto-address\" title=\"mixin internal address\">".concat(addressParts[0], "--").concat(addressParts[addressParts.length - 1], "</div>");
            } else {
              historyHtml += "<div class=\"crypto-address\" data-address=\"".concat(entry.counter_party.address, "\">").concat(entry.counter_party.address.slice(0, 6), "...").concat(entry.counter_party.address.slice(-8), "</div>");
            }
          } else {
            historyHtml += '<div></div>';
          }
          historyHtml += "<div class=\"saito-only\">".concat(entry.memo || '', "</div>");
          historyHtml += "<div class=\"saito-only history-tx-link\">".concat(this.mod.ticker === 'SAITO' && entry.block_hash ? "<a href=\"/explorer/block/".concat(encodeURIComponent(entry.block_hash), "\">view on explorer</a>") : '', "</div>");
          runningBalance -= Number(entry.amount);
          runningBalance = Number(runningBalance.toFixed(8));
        }
      }
      if (runningBalance > 0) {
        historyHtml += "<div class=\"crypto-timestamp\"></div>\n        <div class=\"crypto-type\">deposit</div>\n        <div class=\"crypto-amount\">".concat(this.app.browser.formatDecimals(runningBalance), "</div>\n        ").concat(formatBalance(runningBalance), "\n        <div class=\"crypto-address\">Starting balance</div>\n        <div class=\"saito-only\"></div>\n        <div class=\"saito-only\"></div>");
      }
      historyHtml += '</div>';
      this.app.browser.replaceElementBySelector(historyHtml, '.wallet-history .transaction-history-table');
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var refreshButton = document.getElementById('wallet-history-refresh');
      if (refreshButton) {
        refreshButton.onclick = function () {
          _this3.mod.fetchHistory(0, function () {
            return _this3.formatHistory();
          });
        };
      }
    }
  }]);
}();
module.exports = WalletHistory;